import { render, staticRenderFns } from "./AppDesktopProfileMenu.vue?vue&type=template&id=63b0b658&scoped=true&"
import script from "./AppDesktopProfileMenu.vue?vue&type=script&lang=js&"
export * from "./AppDesktopProfileMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppDesktopProfileMenu.vue?vue&type=style&index=0&id=63b0b658&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b0b658",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VIcon,VTooltip})
